<section id="caip">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Catholic Affiliate Investment Program (<strong class="highlight"><i>CAIP</i></strong>)</h1>
      </div>
    </div>
  </div>
</section>

<section class="section">
  <div class="container">
    <div class="row">
      <div class="col-md-3">
        <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
          <a (click)="navigate('')" [ngClass]="{'active': friendlyUrl===''}" class="nav-link" id="v-pills-cio-tab" data-bs-toggle="pill" href="#v-pills-cio" role="tab" aria-controls="v-pills-cio" aria-selected="true">Message from our Co-Founder</a>
          <a (click)="navigate('stewardship')" [ngClass]="{'active': friendlyUrl==='stewardship'}" class="nav-link" id="v-pills-investment-policy-tab" data-bs-toggle="pill" href="#v-pills-investment-policy" role="tab" aria-controls="v-pills-investment-policy" aria-selected="false">Enhanced Stewardship Through CAIP Strength</a>
          <a (click)="navigate('benefits')" [ngClass]="{'active': friendlyUrl==='benefits'}" class="nav-link" id="v-pills-investment-philosophy-tab" data-bs-toggle="pill" href="#v-pills-investment-philosophy" role="tab" aria-controls="v-pills-investment-philosophy" aria-selected="false">Benefits of CAIP</a>
          <a (click)="navigate('portfolios')" [ngClass]="{'active': friendlyUrl==='portfolios'}" class="nav-link" id="v-pills-spending-policy-tab" data-bs-toggle="pill" href="#v-pills-spending-policy" role="tab" aria-controls="v-pills-spending-policy" aria-selected="false">Prudent and Faith Based Portfolios</a>
          <a (click)="navigate('exclusion')" [ngClass]="{'active': friendlyUrl==='exclusion'}" class="nav-link" id="v-pills-asset-allocation-tab" data-bs-toggle="pill" href="#v-pills-asset-allocation" role="tab" aria-controls="v-pills-asset-allocation" aria-selected="false">Companies We Exclude</a>
          <a (click)="navigate('approach')" [ngClass]="{'active': friendlyUrl==='approach'}" class="nav-link" id="v-pills-alternative-investing-tab" data-bs-toggle="pill" href="#v-pills-alternative-investing" role="tab" aria-controls="v-pills-alternative-investing" aria-selected="false">Our Approach</a>
          <a (click)="navigate('governance')" [ngClass]="{'active': friendlyUrl==='governance'}" class="nav-link" id="v-pills-portfolio-process-tab" data-bs-toggle="pill" href="#v-pills-portfolio-process" role="tab" aria-controls="v-pills-portfolio-process" aria-selected="false">Our Approach to Stewardship and Governance</a>
        </div>
      </div>
      <div class="col-md-9">
        <div class="tab-content" id="v-pills-tabContent">
          <div [ngClass]="{'show active': friendlyUrl===''}" class="tab-pane fade show" id="v-pills-cio" role="tabpanel" aria-labelledby="v-pills-cio-tab">
            <h3>A Message from Our Co-Founder</h3>
            <p>Since 2009, Investing for Catholics has served Catholic investors by aligning their
              faith with their investments. As a fiduciary partner, we share your desire for optimal
              investment stewardship that can both grow and protect the assets that support your
              ministries. In keeping with that effort, I am excited to share with you our latest
              innovation: <strong class="highlight"><i>The Catholic Affiliate Investment Program (CAIP)</i></strong>. </p>

              <p><strong class="highlight"><i>CAIP</i></strong> is a standardized and flexible investment management program designed to
              provide the best opportunity for investment success in each of your locations. <strong class="highlight"><i>CAIP</i></strong>
              delivers a fiduciary standard of care and best practices, including professional fiduciary
              portfolio management; risk-appropriate asset allocation models implemented by a
              fiduciary advisor; low costs through group pricing; passively managed fund solutions
              to maximize diversification; and assurance that funds closely align with the USCCB's
            guidelines for investing.</p>

            <p>When your diocese adopts <strong class="highlight"><i>CAIP</i></strong>, each location will work directly with IFC's vice
            president and co-founder, Mary Brunson to ensure the optimal asset allocation is
            identified, documented and managed. Each will have their own custodial account(s),
            separate reporting and administrative support, while keeping fees low and standards
            high. IFC's sound and repeatable process will elevate the standard of investment care
          across your diocese. </p>

          <p>On behalf of Investing for Catholics, thank you for the opportunity to provide valuable
          services to support your mission and ministries. </p>

        </div>
        <div [ngClass]="{'show active': friendlyUrl==='stewardship'}" class="tab-pane fade" id="v-pills-investment-policy" role="tabpanel" aria-labelledby="v-pills-investment-policy-tab">
          <h3>ENHANCED STEWARDSHIP THROUGH <strong class="highlight"><i>CAIP</i></strong> STRENGTH</h3>
          <p><strong class="highlight"><i>CAIP</i></strong> empowers you and your diocese to shore up and strengthen investment
          standards and management for every location across your diocese. Our sound and
          repeatable process will help your locations streamline finance council duties, while
          at the same time, deliver institutional, low-cost, professionally managed portfolios
        that are screened to closely align with Catholic values. </p>

        <p>And the best part: <strong class="highlight"><i>CAIP</i></strong> is delivered by an experienced fiduciary, with particular
      expertise in Catholic investment management. </p>
      <img src="/images/enhanced-stewardship.jpg" class="mt-3 mb-3 img-fluid" alt="Enhanced Stewardship">
    </div>
    <div [ngClass]="{'show active': friendlyUrl==='benefits'}" class="tab-pane fade" id="v-pills-investment-philosophy" role="tabpanel" aria-labelledby="v-pills-investment-philosophy-tab">
      <h3>BENEFITS OF IFC'S CAIP</h3>
      <ul class="caip">
        <li><strong>Experienced and Professional Institutional Investment
        Management:</strong> IFC is a leader in investment management for Catholic
        dioceses and affiliated organizations. For more than {{ yearsInBusiness }} years, IFC has
        provided risk-appropriate investment portfolios and fiduciary investment
        management services to Catholic organizations. We know what matters to
      you and your organization. </li>
      <li><strong>Catholic Values Investments:</strong> IFC builds its diversified Index Portfolios
      with low-cost index funds that are screened to closely align with the USCCB
    Guidelines for Investing. </li>
    <li><strong>A Standardized Investment Program Throughout the Diocese:</strong>
    No more ad hoc committees at the individual location level. IFC's professional
    advice service, portfolio implementation, and investment policy will ensure
    that each entity has a high degree of service and support from a fiduciary
  advisor who will apply best practices for portfolio success. </li>
  <li><strong>A Standardized Investment Policy Statement (IPS) Template:</strong>
  Designed with flexibility to implement 10-20 asset allocation models, enabling
  each entity to implement the asset allocation(s) most suitable to their needs,
while also documenting the application of fiduciary best practices. </li>
<li><strong>Individual Location Account Autonomy:</strong> Locations retain the latitude
to invest in the asset allocation that is most suitable for them and benefit from
a dedicated IFC advisor, all while enjoying a location-specific custodial account
and performance reporting.</li>
<li><strong>Group Buying Power:</strong> CAIP delivers low fees through diocesan-wide
aggregation and standardized professional investment management. </li>
</ul>
</div>
<div [ngClass]="{'show active': friendlyUrl==='portfolios'}" class="tab-pane fade" id="v-pills-spending-policy" role="tabpanel" aria-labelledby="v-pills-spending-policy-tab">
  <h3>PRUDENT AND FAITH-BASED PORTFOLIOS</h3>
  <p>IFC utilizes low-cost blends of faith-consistent index funds to provide risk-appropriate,
    globally diversified investment portfolios. IFC's globally diversified portfolios are
    screened to closely align with the United States Conference of Catholic Bishops
  guidelines for investing, excluding companies as detailed on the following page. </p>

  <p>IFC's <strong class="highlight"><i>CAIP</i></strong> provides as many as 20 Index Portfolio allocations that enable a targeted
  approach to risk and expected return. Comprised of easy-to-own daily-valued mutual
  funds, the portfolios invest in publicly traded companies throughout the US, International
  Developed and Emerging markets. Even greater diversification comes from an allocation
  to Real Estate Investment Trusts (REITs). The fixed income portion of the IFC Index
Portfolios is comprised of a Catholic Values-screened Global bond mutual fund.</p>

<p>The general asset class allocations for IFC's 20 Index Portfolios are shown in the
chart below.</p>

<img src="/images/IFC-asset-location-chart.jpg" class="mt-3 mb-3 img-fluid" alt="asset class allocations for IFC's 20 Index Portfolios ">

</div>
<div [ngClass]="{'show active': friendlyUrl==='exclusion'}" class="tab-pane fade" id="v-pills-asset-allocation" role="tabpanel" aria-labelledby="v-pills-asset-allocation-tab">
  @if (exclusions) {
    <div [innerHtml]="exclusions[0].html | safe: 'html'"></div>
  }

</div>
<div [ngClass]="{'show active': friendlyUrl==='approach'}" class="tab-pane fade" id="v-pills-alternative-investing" role="tabpanel" aria-labelledby="v-pills-alternative-investing-tab">
  <h3>A DUAL APPROACH TO FAITH-BASED INVESTING</h3>
  <p>In their investing guidelines, the USCCB emphasizes the importance of active
  ownership through corporate engagement to promote Catholic social teaching. </p>

  <p>Therefore, in addition to the comprehensive exclusionary screening process that
    is incorporated in the funds that make up the IFC portfolios, fund managers also
    implement an ongoing governance and stewardship program. Fund managers
    actively communicate with included company boards to maximize the alignment of
    interests of boards and management with those of shareholders, and as they pertain
  to social concerns.</p>

  <p>
    A properly implemented governance and stewardship program has the potential of
    adding real value to the overall portfolio by helping constituent companies benefit
    from open dialogue relating to potentially costly, but avoidable pitfalls such as fines,
    lawsuits and costly negative headlines. This stewardship and governance program
    cuts across the globe, incorporating a wide array of geographic and social issues,
    including but not limited to: board composition; human labor and dignity; workplace
    safety and conditions; pay equality and living wages; management compensation;
    carbon emissions, etc.. Fund manager approach is to engage companies in dialogue
    to understand their positions in regard to relevant issues, as opposed to a prescriptive
    approach, while also aware of the option of voting proxies or divesting if a satisfactory
    resolution cannot be achieved.
  </p>

</div>
<div [ngClass]="{'show active': friendlyUrl==='governance'}" class="tab-pane fade" id="v-pills-portfolio-process" role="tabpanel" aria-labelledby="v-pills-portfolio-process-tab">
  <h3>A GLOBAL APPROACH TO STEWARDSHIP AND GOVERNANCE</h3>
  <p>IFC currently builds its Index Portfolios with select funds from Dimensional Fund
    Advisors. The graphics on this page detail the enormous depth and scope of the
    stewardship and governance program that
    Dimensional implements on behalf of all of
    its shareholders, and across all of its funds.
    Take note of the fact that the majority of
    engagements undertaken in proxy year 2024
    pertained to both environmental and social
    matters. Also note that engagements occurred
    for portfolio companies across all geographic
    sectors, including US, Canada, Emerging and
  Developed International markets. </p>
  <img src="//data.ifa.com/content/charts/696/8103/8103.png" class="mt-3 mb-3 img-fluid" alt="Engagement by topic 2024">

</div>
</div>
</div>
</div>

</div>
</section>